export default {
  name: 'Acanvas',
  props: {
    id: { type: String, default: () => (`a-canvas-${Math.random().toString().substring(2)}`) },
  },
  data() {
    return ({
      canvas: null,
      width: null,
      height: null,
    });
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    create() {
      this.$nextTick(() => {
        !this.width && (this.width = this.$el.clientWidth);
        !this.height && (this.height = this.$el.clientHeight);
        this.$nextTick(() => {
          !this.canvas && (this.canvas = this.$el.getContext('2d'));
          this.$nextTick(() => this.draw());
        });
      });
    },
    draw() {
      let progress = 0
      const animate = () => {
        this.canvas.clearRect(0, 0, this.width, this.height);
        this.canvas.beginPath();
        this.canvas.moveTo(50, 50);
        this.canvas.lineTo(50 + progress * 400, 50);
        this.canvas.lineWidth = 2;
        this.canvas.strokeStyle = `hsl(${progress * 120}, 100%, 50%)`;
        this.canvas.stroke();
        progress += 0.01;
        if (progress < 1) requestAnimationFrame(animate);
      }
      animate();
    },
    revoke() {
      this.width = null;
      this.height = null;
      this.$nextTick(() => {
        this.canvas = null;
      });
    },
  },
  render() {
    const { padding, margin, width = '100%', height = '100%', background } = this.$attrs;
    return (<canvas class="a-canvas" id={this.id} style={{ padding, margin, width, height, background }} />);
  }
}